<ion-list>
  <ion-item *ngFor="let item of media; let i = index" detail="false" button (click)="verMedia(i)" [ngClass]="{'item-selected': selected == i}">
    <ion-icon slot="start" class="text-xl text-gray-700" [name]="verificarIconMedia(item.tipo)"></ion-icon>
    <ion-label>{{ item.titulo || item.tipo }}</ion-label>
  </ion-item>
</ion-list>